// extracted by mini-css-extract-plugin
export default {"main":"_1b1f61c666","tit":"d9b5537dac","maintitle":"_96d496c540","ylw":"_647c587219","white":"ce2ff3fd41","mv_title":"_02d548f95a","mv_nc":"_0b7af4039d","mv_in":"_1c62916a22"};